// Achievements data
import { stats } from './stats';

export interface Achievement {
  id: string;
  title: {
    en: string;
    ar: string;
  };
  description: {
    en: string;
    ar: string;
  };
  year: number;
  category: 'championship' | 'partnership' | 'milestone' | 'recognition';
  icon: string;
}

export const achievements: Achievement[] = [
  {
    id: "1",
    title: { en: "Academy Founded", ar: "تأسيس الأكاديمية" },
    description: {
      en: "Champions Academy was established, launching its journey in sports development in Gaza.",
      ar: "تم تأسيس أكاديمية تشامبيونز، لتبدأ مسيرتها في التطوير الرياضي في غزة."
    },
    year: 2015,
    category: 'milestone',
    icon: "Star"
  },
  {
    id: "2",
    title: { en: "Expansion Across Gaza with 3 Branches", ar: "التوسع في قطاع غزة بـ 3 فروع" },
    description: {
      en: "Expanded across the Gaza Strip by opening three branches to reach more athletes.",
      ar: "التوسع في قطاع غزة بافتتاح ثلاثة فروع للوصول إلى عدد أكبر من اللاعبين."
    },
    year: 2016,
    category: 'milestone',
    icon: "Target"
  },
  {
    id: "3",
    title: { en: "World's First Academy for Cancer Patients", ar: "افتتاح أول أكاديمية لمرضى السرطان في العالم" },
    description: {
      en: "Opened the world's first sports academy dedicated to children battling cancer.",
      ar: "افتتاح أول أكاديمية رياضية في العالم مخصصة للأطفال المصابين بالسرطان."
    },
    year: 2017,
    category: 'milestone',
    icon: "Star"
  },
  {
    id: "4",
    title: { en: "First Family Club in Palestine", ar: "افتتاح أول نادي عائلي في فلسطين" },
    description: {
      en: "Opened the first family sports club in Palestine, welcoming entire families to train together.",
      ar: "افتتاح أول نادٍ رياضي عائلي في فلسطين، يرحب بالعائلات للتدرب معاً."
    },
    year: 2018,
    category: 'milestone',
    icon: "Star"
  },
  {
    id: "5",
    title: { en: "Multiple Academies for Both Genders", ar: "افتتاح أكاديميات متعددة لكلا الجنسين" },
    description: {
      en: "Launched multiple academies open to both boys and girls.",
      ar: "افتتاح أكاديميات متعددة مفتوحة للذكور والإناث على حد سواء."
    },
    year: 2018,
    category: 'milestone',
    icon: "Target"
  },
  {
    id: "6",
    title: { en: "First International Tournament — Donosti Cup", ar: "المشاركة في أول بطولة دولية — الدونستي كاب" },
    description: {
      en: "Participated in our first international tournament, the Donosti Cup in Spain.",
      ar: "المشاركة في أول بطولة دولية، الدونستي كاب في إسبانيا."
    },
    year: 2019,
    category: 'milestone',
    icon: "Star"
  },
  {
    id: "7",
    title: { en: "Partnership with the Donosti Cup", ar: "شراكة مع إدارة بطولة دونستي كاب" },
    description: {
      en: "Established a partnership with the management of the Donosti Cup tournament.",
      ar: "عقد شراكة مع إدارة بطولة دونستي كاب."
    },
    year: 2019,
    category: 'partnership',
    icon: "Handshake"
  },
  {
    id: "8",
    title: { en: "First Champions Olympiad for Private Schools", ar: "أول أولمبياد في تشامبيونز للمدارس الخاصة" },
    description: {
      en: "Hosted the first Champions Olympiad for private schools.",
      ar: "استضافة أول أولمبياد في تشامبيونز للمدارس الخاصة."
    },
    year: 2020,
    category: 'milestone',
    icon: "Target"
  },
  {
    id: "9",
    title: { en: "Best Academy in Palestine", ar: "أفضل أكاديمية في فلسطين" },
    description: {
      en: "Named the best academy in Palestine by the Higher Council for Youth and Sports.",
      ar: "اختيارها أفضل أكاديمية في فلسطين من المجلس الأعلى للشباب والرياضة."
    },
    year: 2020,
    category: 'recognition',
    icon: "Award"
  },
  {
    id: "10",
    title: { en: "Individual Titles in Table Tennis", ar: "حصد ألقاب فردية في تنس الطاولة" },
    description: {
      en: "Won individual titles in table tennis competitions.",
      ar: "حصد ألقاب فردية في مسابقات تنس الطاولة."
    },
    year: 2020,
    category: 'championship',
    icon: "Medal"
  },
  {
    id: "11",
    title: { en: "Individual Titles in Karate", ar: "حصد ألقاب فردية في الكاراتيه" },
    description: {
      en: "Won individual titles in karate competitions.",
      ar: "حصد ألقاب فردية في مسابقات الكاراتيه."
    },
    year: 2020,
    category: 'championship',
    icon: "Medal"
  },
  {
    id: "12",
    title: { en: "First Two Football Titles (Born 2006–2008)", ar: "أول لقبين في كرة القدم (مواليد 2006–2008)" },
    description: {
      en: "Won our first two football titles at the academy level for the 2006–2008 age groups.",
      ar: "حصد أول لقبين في كرة القدم على مستوى الأكاديميات لمواليد 2006–2008."
    },
    year: 2020,
    category: 'championship',
    icon: "Trophy"
  },
  {
    id: "13",
    title: { en: "Partnership with Regional Sport", ar: "شراكة مع شركة ريجينال سبورت" },
    description: {
      en: "Signed a partnership with Regional Sport for sports marketing.",
      ar: "عقد شراكة مع شركة ريجينال سبورت للتسويق الرياضي."
    },
    year: 2020,
    category: 'partnership',
    icon: "Handshake"
  },
  {
    id: "14",
    title: { en: "Partnership with Real Madrid Foundation", ar: "شراكة مع مؤسسة ريال مدريد" },
    description: {
      en: "Established a partnership with the Real Madrid Foundation.",
      ar: "عقد شراكة مع مؤسسة ريال مدريد."
    },
    year: 2020,
    category: 'partnership',
    icon: "Handshake"
  },
  {
    id: "15",
    title: { en: "Federation Football Championship (Born 2008)", ar: "بطولة الاتحاد لكرة القدم (مواليد 2008)" },
    description: {
      en: "Won the Football Federation championship for the 2008 age group.",
      ar: "حصد بطولة الاتحاد لكرة القدم لمواليد 2008."
    },
    year: 2021,
    category: 'championship',
    icon: "Trophy"
  },
  {
    id: "16",
    title: { en: "Palestinian 3x3 Girls' Basketball Championship", ar: "بطولة الاتحاد الفلسطيني لكرة السلة الثلاثية للفتيات" },
    description: {
      en: "Won the Palestinian Basketball Federation's 3x3 championship for girls.",
      ar: "حصد بطولة الاتحاد الفلسطيني لكرة السلة الثلاثية (3×3) للفتيات."
    },
    year: 2021,
    category: 'championship',
    icon: "Trophy"
  },
  {
    id: "17",
    title: { en: "1st Place — Federation Karate Championship", ar: "مركز أول في بطولات الاتحاد للكاراتيه" },
    description: {
      en: "Took first place in the Karate Federation championships.",
      ar: "حصد المركز الأول في بطولات الاتحاد للكاراتيه."
    },
    year: 2021,
    category: 'championship',
    icon: "Medal"
  },
  {
    id: "18",
    title: { en: "1st Place — Federation Table Tennis Championship", ar: "مركز أول في بطولة الاتحاد لتنس الطاولة" },
    description: {
      en: "Took first place in the Table Tennis Federation championship.",
      ar: "حصد المركز الأول في بطولة الاتحاد لتنس الطاولة."
    },
    year: 2022,
    category: 'championship',
    icon: "Medal"
  },
  {
    id: "19",
    title: { en: "Three Players Selected for Palestine's National Team", ar: "اختيار 3 لاعبين لمنتخب فلسطين" },
    description: {
      en: "Three of our players were selected to represent Palestine's national team.",
      ar: "تمثيل لاعبينا في منتخب فلسطين باختيار 3 لاعبين."
    },
    year: 2022,
    category: 'milestone',
    icon: "Star"
  },
  {
    id: "20",
    title: { en: "First Player Turns Professional in Barcelona", ar: "احتراف أول لاعب في برشلونة" },
    description: {
      en: "Our first player turned professional, joining the Wisbak academy in Barcelona.",
      ar: "احتراف أول لاعب في أكاديمية ويس باك في مدينة برشلونة."
    },
    year: 2022,
    category: 'milestone',
    icon: "Star"
  },
  {
    id: "21",
    title: { en: "Table Tennis Training Camp in Egypt", ar: "معسكر تدريبي لتنس الطاولة في مصر" },
    description: {
      en: "Held a training camp for Champions' table tennis players in Egypt.",
      ar: "إقامة معسكر تدريبي للاعبي تشامبيونز في تنس الطاولة في مصر."
    },
    year: 2022,
    category: 'milestone',
    icon: "Target"
  },
  {
    id: "22",
    title: { en: "Partnership with Nafs Sports — Egypt", ar: "شراكة مع شركة نافس للرياضات — مصر" },
    description: {
      en: "Signed a partnership with Nafs Sports and Experiences in Egypt.",
      ar: "عقد شراكة مع شركة نافس للرياضات والمعايشات في مصر."
    },
    year: 2022,
    category: 'partnership',
    icon: "Handshake"
  },
  {
    id: "23",
    title: { en: "Gaza Strip Table Tennis Cup", ar: "بطولة كأس القطاع لتنس الطاولة" },
    description: {
      en: "Won the Gaza Strip Cup in table tennis.",
      ar: "حصد بطولة كأس القطاع لتنس الطاولة."
    },
    year: 2022,
    category: 'championship',
    icon: "Trophy"
  },
  {
    id: "24",
    title: { en: "Girls' Basketball Championship", ar: "بطولة كرة السلة للفتيات" },
    description: {
      en: "Won the girls' basketball championship.",
      ar: "حصد بطولة كرة السلة للفتيات."
    },
    year: 2022,
    category: 'championship',
    icon: "Trophy"
  },
  {
    id: "25",
    title: { en: "Hosting a Real Madrid Coach", ar: "استضافة مدرب من ريال مدريد" },
    description: {
      en: "Hosted a coach from Real Madrid for our players.",
      ar: "استضافة مدرب من ريال مدريد للاعبينا."
    },
    year: 2023,
    category: 'milestone',
    icon: "Star"
  },
  {
    id: "26",
    title: { en: "Real Madrid Camp in Jerusalem", ar: "المشاركة في معسكر ريال مدريد في القدس" },
    description: {
      en: "Participated in the Real Madrid camp held in Jerusalem.",
      ar: "المشاركة في معسكر ريال مدريد في القدس."
    },
    year: 2023,
    category: 'milestone',
    icon: "Star"
  },
  {
    id: "27",
    title: { en: "Dabke Academy Camp in the West Bank", ar: "معسكر أكاديمية الدبكة في الضفة الغربية" },
    description: {
      en: "Took part in a training camp for the Dabke academy in the West Bank.",
      ar: "المشاركة في معسكر تدريبي لأكاديمية الدبكة في الضفة الغربية."
    },
    year: 2023,
    category: 'milestone',
    icon: "Target"
  },
  {
    id: "28",
    title: { en: "Advanced Positions — Federation Table Tennis", ar: "مراكز متقدمة في بطولة الاتحاد لتنس الطاولة" },
    description: {
      en: "Secured advanced positions in the Table Tennis Federation championship.",
      ar: "حصد مراكز متقدمة في بطولة الاتحاد لتنس الطاولة."
    },
    year: 2023,
    category: 'championship',
    icon: "Medal"
  },
  {
    id: "29",
    title: { en: "1st Place — Division Three Table Tennis", ar: "المركز الأول في تنس الطاولة للدرجة الثالثة" },
    description: {
      en: "Won first place in the Division Three table tennis championship.",
      ar: "حصد المركز الأول في بطولة تنس الطاولة للدرجة الثالثة."
    },
    year: 2023,
    category: 'championship',
    icon: "Trophy"
  },
  {
    id: "30",
    title: { en: "Sports Technology in Academy Training", ar: "استخدام التكنولوجيا الرياضية في التدريبات" },
    description: {
      en: "Introduced sports technology into the academy's training programs.",
      ar: "استخدام التكنولوجيا الرياضية في التدريبات الأكاديمية."
    },
    year: 2023,
    category: 'milestone',
    icon: "Target"
  },
  {
    id: "31",
    title: { en: "Dabke Academy Art Performances", ar: "العروض الفنية لأكاديمية الدبكة" },
    description: {
      en: "Took part in numerous art performances with the Dabke academy.",
      ar: "المشاركة في العديد من العروض الفنية لأكاديمية الدبكة."
    },
    year: 2023,
    category: 'milestone',
    icon: "Star"
  },
  {
    id: "32",
    title: { en: "Federation Football Championship — Gaza (Born 2006)", ar: "بطولة الاتحاد لكرة القدم — غزة (مواليد 2006)" },
    description: {
      en: "Won the Football Federation championship for the 2006 age group at the Gaza Strip level for clubs and academies.",
      ar: "حصد بطولة الاتحاد لكرة القدم لمواليد 2006 على مستوى قطاع غزة للأندية والأكاديميات."
    },
    year: 2023,
    category: 'championship',
    icon: "Trophy"
  }
];

export const timeline = stats.milestones;
